/**
 * Returns the indices of duplicate array entries, or an empty
 * array if none are found.
 */
export function findDuplicateIndices<T>(input: T[]): number[] {
  return input
    .map((item, index, arr) => (index !== arr.indexOf(item) ? index : null))
    .filter((item) => item !== null) as number[];
}
